import { useRouter } from 'next/router'
import Link from 'next/link'
import Header from "../src/local/Header"
import styles from '../styles/Hirforrasok.module.css'
import ErrorBoundary from "../src/local/ErrorBoundary"


type ItemType = {
	name: string
	place?: string
	phone?: string
	email?: string
	web?: string
}

export default function Elerhetoseg() {

	const items: ItemType[] = [
		{
			name: "Gádoros - Progádor Nonprofi Kft",
			place: "5932 Gádoros, Kossuth utca 1",
			phone: "06 68/490-037",
			email: "progador@oroscom.hu",
			web: "https://www.gadoros.hu"
		},
		{
			name: "Alsómocsolád Község Önkormányzata",
			place: "7345 Alsómocsolád, Rákóczi utca 21",
			phone: "+36 (72) 451-748",
			email: "mocsolad@t-online.hu",
			web: "https://www.alsomocsolad.hu"
		},
		{
			name: "Üllő Város Önkormányzata",
			place: "2225 Üllő, Templom tér 3.",
			phone: "(29) 320-011",
			email: "titkarsag@ullo.hu",
			web: "https://www.ullo.hu",
		},
		{
			name: "Maglód Város Önkormányzata",
			place: "Maglód, Fő utca 12",
			phone: "(29) 325-111 2234",
			email: "fajka.szilvia@maglod.hu",
			web: "https://www.maglod.hu"
		},
		{
			name: "Gyömrő Város Önkormányzata",
			place: "2230 Gyömrő, Szabadság tér 1 ",
			phone: "+36 29 330 011",
			email: "titkarsag@gyomro.hu",
			web: "https://www.gyomro.hu"
		},
		{
			name: "Bugyi Nagyközség Önkormányzata",
			place: "2347 Bugyi, Bereznay Tér 1.",
			phone: "+36 29 547 502",
			email: "hivatal@bugyi.hu",
			web: "http://www.bugyi.hu"
		},
		{
			name: "Ócsa Város Önkormányzata",
			place: "2364 Ócsa, Bajcsy - Zsilinszky u. 2.",
			phone: "+36 29 378 125",
			email: "polghiv@ocsa.hu",
			web: "https://www.ocsa.hu"
		},
		{
			name: "Monorierdő Önkormányzata",
			place: "2213 Monorierdő, Szabadság u. 50/A",
			phone: "+36 29 419 103",
			email: "titkarsag@monorierdo.hu",
			web: "https://monorierdo.hu"
		}
	]

	const Item = (v: ItemType) => {
		return (
			<p>
				<b>{v.name}</b><br />
				{v.place && <>Székhely: {v.place}<br /></>}
				{v.phone && <>Telefonszám: {v.phone}<br /></>}
				{v.email && <>E-mail: {v.email}<br /></>}
				{v.web && <>Weboldal: <Link href={v.web} className={styles.blue}>{v.web}</Link><br /></>}
			</p>
		)
	}

	return (
		<ErrorBoundary>
			<h3 className={styles.box}>
				Települési hírforrások
			</h3>
			{/*<div className={styles.listbox}>*/}

			<div className={styles.listbox}>
				A HolmiApp applikációban megjelenő információk feltöltését, a települések által kijelölt helyi, hivatalos adminisztrátorok végzik.
				<br /><br />
				The information displayed in the HolmiApp application is uploaded by local, official administrators appointed by the municipalities.
				<br />
				We do not publish news. Our news sources do this!
			</div>
			<div className={styles.listbox}>
				{items.sort((a, b) => a.name.localeCompare(b.name)).map(e => Item(e))}
			</div>
			<h3 className={styles.box}>
				Kapcsolat
			</h3>
			<div className={styles.listbox}>
				<p>A HolmiApp applikációt a <b>K&K Fejlesztő Kft.</b> fejleszti.<br /><br />
					E-mail: info (kukac) holmiapp (pont) hu<br />
					Telefon: +36 50 127 8309<br />
					Weboldal: <Link href="https://holmiapp.hu/" className={styles.blue}>https://holmiapp.hu/</Link>
				</p>
			</div>
		</ErrorBoundary>
	)
}